import { Navigate, useLocation, useParams } from "react-router-dom";
import { PageContainer } from "@volca/ui/components/ui/page-components";
import { Spinner } from "@volca/ui/components/ui/spinner";
import { useGetBusiness } from "@/business/query";
import { FEATURE_FLAG_NAMES } from "@/core/feature-flags/feature-flag-name";
import { useFeatureFlag } from "@/core/feature-flags/use-feature-flag";
import { JobCostingContent } from "@/profitability/job-costing-content";
import { canManageProfitability } from "@/profitability/routes";
import {
  LEGACY_REPORTS_PATH,
  PROFITABILITY_PATH,
  PROFITABILITY_AGENTS_PATH,
} from "@/profitability/routes";
import { ServiceTitanContent } from "@/profitability/service-titan-content";
import { VersionedRunDetail } from "@/profitability/versioned-run-detail";
import { useGetMyUser } from "@/user/query";

export const ProfitabilityContent = ({
  businessId,
}: {
  businessId: string;
}) => {
  const { data: business } = useGetBusiness(businessId);
  const { data: user } = useGetMyUser();
  const { runId } = useParams();
  const { pathname } = useLocation();
  const { enabled: documentsOnly, isLoading: loadingFlag } = useFeatureFlag(
    FEATURE_FLAG_NAMES.profitability_documents_only,
  );
  if (loadingFlag)
    return (
      <PageContainer>
        <Spinner layout="centered" aria-label="Loading Job Costing" />
      </PageContainer>
    );
  // The agents are listed on Job Costing itself.
  if (pathname.replace(/\/+$/, "") === PROFITABILITY_AGENTS_PATH)
    return <Navigate to={PROFITABILITY_PATH} replace />;
  if (pathname === LEGACY_REPORTS_PATH)
    return canManageProfitability(user) &&
      business?.profitability_workflows?.includes(1) !== false ? (
      <ServiceTitanContent businessId={businessId} />
    ) : (
      <Navigate to={PROFITABILITY_PATH} replace />
    );
  if (runId)
    return (
      <VersionedRunDetail key={runId} businessId={businessId} runId={runId} />
    );
  const templateRoute = pathname.startsWith(`${PROFITABILITY_AGENTS_PATH}/`);
  if (templateRoute && !documentsOnly)
    return <Navigate to={PROFITABILITY_PATH} replace />;
  return documentsOnly ? (
    <JobCostingContent businessId={businessId} />
  ) : (
    <ServiceTitanContent businessId={businessId} />
  );
};
